/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './user-header.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/common';
import * as import3 from '../../../../app/user-management/user-header/user-header.component';
import * as import4 from '../../../../app/shared/router/linkhelper';
import * as import5 from '@angular/router';
import * as import6 from '@angular/material';
const styles_UserHeaderComponent:any[] = [import0.styles];
export const RenderType_UserHeaderComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_UserHeaderComponent,
  data: {}
}
);
function View_UserHeaderComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'id',
        'lnkSettings'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.linkClick(co.linkName.usermanagement,['/user-management'])) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),['Manage Users']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = ck(v,2,0,co.isActiveLink(co.linkName.usermanagement));
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_UserHeaderComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵted((null as any),['\n	'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),11,'section',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n				'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'id',
        'lnkProfile'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.UserHeaderComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.linkClick(co.linkName.profile,[
          '/user-management',
          'profile'
        ]
        )) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),['Profile Info'])),
    (l()(),import1.ɵted((null as any),['\n\n				'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),3,'a',[[
        'id',
        'lnkProfilePass'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:import3.UserHeaderComponent = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.linkClick(co.linkName.change_pass,[
          '/user-management',
          'secure_pass'
        ]
        )) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(278528,(null as any),0,import2.NgClass,[
      import1.IterableDiffers,
      import1.KeyValueDiffers,
      import1.ElementRef,
      import1.Renderer
    ]
      ,{ngClass: [
        0,
        'ngClass'
      ]
    },(null as any)),
    import1.ɵpod(['active']),
    (l()(),import1.ɵted((null as any),['Change Password'])),
    (l()(),import1.ɵted((null as any),['\n\n	'])),
    (l()(),import1.ɵted((null as any),['\n			'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'section',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n				'])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_UserHeaderComponent_1)),
    import1.ɵdid(16384,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n			'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import3.UserHeaderComponent = v.component;
    const currVal_0:any = ck(v,5,0,co.isActiveLink(co.linkName.profile));
    ck(v,4,0,currVal_0);
    const currVal_1:any = ck(v,10,0,co.isActiveLink(co.linkName.change_pass));
    ck(v,9,0,currVal_1);
    const currVal_2:any = co.canShowLink('user-management');
    ck(v,17,0,currVal_2);
  },(null as any));
}
function View_UserHeaderComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(16777216,(null as any),(null as any),1,'app-user-header',([] as any[]),(null as any),(null as any),(null as any),View_UserHeaderComponent_0,RenderType_UserHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import3.UserHeaderComponent,[
      import4.LinkAuth,
      import5.Router,
      import6.MdDialog,
      import1.ViewContainerRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const UserHeaderComponentNgFactory:import1.ComponentFactory<import3.UserHeaderComponent> = import1.ɵccf('app-user-header',import3.UserHeaderComponent,View_UserHeaderComponent_Host_0,{
  payrollBillingModel: 'payrollBillingModel',
  oldModel: 'oldModel'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/user-management/user-header/user-header.component.ngfactory.ts